export default "__VITE_PUBLIC_ASSET__176bdca8__"